import { Box, Button, Card, CardActions, CardContent, Container, LinearProgress, Stack, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Barcode from 'react-barcode'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { IUser } from '../../interface/IUser';
import { AxiosInstance } from '../../api/apiInstance';
import { IProducts } from '../../interface/IProducts';
import ProductLocations from './ProductLocations';
import ProductHierarchy from './ProductHierarchy';

function ProductItem() {
  const userinfo: IUser = useSelector((state: any) => state.user)
  const navigate = useNavigate();
  const [singleData, setSingleData] = useState<IProducts>({} as IProducts);
  let { productId } = useParams();
  const [showSpinner, setShowSpinner] = useState(true);


  async function GetPart() {
      const product = await AxiosInstance({
        // url of the api endpoint (can be changed)
        url: "priorityProducts/findOne/" + productId,
        method: "GET",
      }).then((res) => {
        // handle success
        const tmpRes: IProducts = res.data;
        return tmpRes;
      });      
      setSingleData(product);
      setShowSpinner(false);
    }
  
  useEffect(() => {
    GetPart();
    }, [])
  
  
  return (
    <Container component="main"  >

   
    <Box

      //my={2}
      display="flex"
      flexDirection={"column"}
      alignItems="center"
      gap={2}
      p={2}
      m={2}
      borderRadius={"1rem"}
      bgcolor={"#f6eeee"}
      boxShadow= {1}
      >
         {showSpinner ?
                    <LinearProgress /> : <></>}
      <Stack direction={'row'} spacing={2}>
        <Card sx={{ maxWidth: 645, minWidth: 500 }}>

          <CardContent>
            <Typography gutterBottom variant="body2" component="div">
              Part: {singleData?.PARTNAME}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <Barcode displayValue={false} width={1.8} height={40} value={singleData?.BARCODE} />
            </Typography>

            <Typography variant="body2" >
              Description: {singleData?.PARTDES}
            </Typography>           

          </CardContent>
          <CardActions>
            <Button onClick={()=>{navigate('/Products')}}>
              Back
            </Button>
          </CardActions>
        </Card>        
      </Stack>
      <Stack direction={'row'} spacing={10}>
        <ProductLocations/>
        <ProductHierarchy/>
      </Stack>
      </Box>
      </Container>
  )
}

export default ProductItem
